let IndexFiltersMode = /*#__PURE__*/function (IndexFiltersMode) {
  IndexFiltersMode["Default"] = "DEFAULT";
  IndexFiltersMode["Filtering"] = "FILTERING";
  IndexFiltersMode["EditingColumns"] = "EDITING_COLUMNS";
  return IndexFiltersMode;
}({});

export { IndexFiltersMode };
